import {
  normalizeAtPathForBrowser,
  normalizeAtPathForRouter,
} from '@wellesley/router'

type LocationParts = {
  pathname: string
  search: string
  hash: string
}

export const buildPath = (location: LocationParts) =>
  `${location.pathname}${location.search}${location.hash}`

export const createPathNormalizer = () => ({
  toRouterPath: (location: LocationParts) =>
    buildPath({
      pathname: normalizeAtPathForRouter(location.pathname),
      search: location.search,
      hash: location.hash,
    }),
  toBrowserPath: (location: LocationParts) =>
    buildPath({
      pathname: normalizeAtPathForBrowser(location.pathname),
      search: location.search,
      hash: location.hash,
    }),
})
